import { Colour } from '../../core/models/colour'
import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { RestQuery } from '../../rest/utilities/rest-query'
import { Department } from './department'

@Mapped(
  {
    department: { format: Department.create },
    hq_workshop: { property: 'hqWorkshop' },
    midlands_workshop: { property: 'midlandsWorkshop' },
    colour: { format: Colour.create },
  },
  ['numericID', 'timestamps']
)
export class Category extends Mappable {
  id!: number
  numericID!: number
  name!: string
  department?: Department
  weekend!: boolean
  hqWorkshop!: boolean
  midlandsWorkshop!: boolean
  supervisor?: string
  colour?: Colour
  index!: number
  created!: Date
  updated!: Date
  deleted!: boolean

  static create<Data>(attrs: Data) {
    return new Category().map(attrs)
  }
}

interface Filters {
  keywords?: string
  archive?: string
}

type Ordering = 'name' | '-name' | 'index' | '-index'

export class CategoryQuery extends RestQuery<Filters, Ordering> {}
